/**
 * Promang-wordmark (inline SVG).
 *
 * Rebygger Promang-logoen som ren SVG slik at den skalerer rent, kan farges
 * dynamisk (dark/light kontekst), og ikke krever en binær assetfil.
 *
 *  - "Pro"  — bold (brand-blå, tung vekt)
 *  - "mang" — tynnere vekt i samme farge (litt redusert opacity gir det
 *             "hårfine" strek-uttrykket logoen har)
 *
 * Props:
 *   - height (number, default 20)     : ønsket høyde i px
 *   - color  (string, default #1F8BD6): hovedfarge på wordmark
 *   - title  (string)                 : aria-tittel for skjermlesere
 *
 * Ved behov kan komponenten enkelt byttes ut med et PNG/SVG-asset uten at
 * kall-stedene trenger å endres.
 */
export function PromangLogo({
  height = 20,
  color = "#1F8BD6",
  title = "Promang",
  style = {},
  ...rest
}) {
  // viewBox er valgt til å matche proporsjonene i logoen (bredde ~3.2× høyde).
  // Vi holder den enkel — SVG <text> rendres med aktuelle webfonter (Space
  // Grotesk er allerede lastet i Airon-stylinga).
  const width = Math.round(height * 3.4);
  const a11yId = `promang-logo-title-${Math.random().toString(36).slice(2, 8)}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 340 100"
      width={width}
      height={height}
      role="img"
      aria-labelledby={a11yId}
      style={{ display: "inline-block", verticalAlign: "middle", ...style }}
      {...rest}
    >
      <title id={a11yId}>{title}</title>
      <text
        x="0"
        y="78"
        fontFamily="'Space Grotesk', 'Inter', system-ui, sans-serif"
        fontSize="90"
        letterSpacing="-2"
        fill={color}
      >
        <tspan fontWeight="700">Pro</tspan>
        <tspan fontWeight="300" opacity="0.92">
          mang
        </tspan>
      </text>
    </svg>
  );
}

export default PromangLogo;
